export default __webpack_public_path__ + "static/media/DOCTORCERTIFICATEFOR5DISEASES.f323e445.png";